/** 轻量 Tron WC 常量/判断，避免主包静态 import walletconnect-tron（含 AppKit 依赖链） */

export const TRON_WC_WALLET_TYPE = 'wallet_connect_tron'

export function isTronWalletConnectProvider(provider) {
  return Boolean(provider && provider.isTronWalletConnect === true)
}
